import React, { PropTypes } from 'react';

export default class MapLayers extends React.Component {

	componentWillMount() {
		this.props.getMapLayers();
	}

	checkboxOrExpand(item, class2add) {
		let type = item.children ? 'expand' : 'check';
		if (type === 'check') {
			return (
				<div className='layer'>
					<input type='checkbox' className={`${class2add}`} id={item.codename} name={item.codename} 
							onChange={this.onCheckboxChange.bind(this, item)} 
							checked={this.visibleLayersListIds.includes(item.id)} />
					<label htmlFor={item.codename} >{item.name}</label>
				</div>
			);
		} else if (type === 'expand') { 
			return (
				<button type='button' className={`collapsible ${class2add}`} 
						onClick={this.onClickExpander.bind(this, item)}>{item.name}</button>
			);
		}
	}

	onCheckboxChange(e) {
		if (this.visibleLayersListIds.includes(e.id)) {
			this.props.removeVisibleLayer(e.id);
			this.props.changeOneMapLayer(e.id, false);
		} else {
			this.props.addVisibleLayer(e);
			this.props.changeOneMapLayer(e.id, true);
		}
	}

	onClickExpander(e) {
		this.props.changeOneMapLayer(e.id, !e.openOrCheck);
	}

	projectsToRender() {
		let renderList = [];
		if (this.props.projects.isMariana) {
			renderList.push(1);
		}
		if (this.props.projects.isBrumadinho) {
			renderList.push(2);
		}
		
		if (this.props.projects.isAssistenciaTecnica) {
			renderList.push(3);
		}

		return renderList;
	}

	renderChildren(item) {
		if (!(this.projectsToRender().includes(item.projeto))) return;
		let _class = '';
		let class2add = '';
		if (item.openOrCheck) { 
			_class = 'content open';
			class2add = 'active';
		} else { 
			_class = 'content close';
		}
		return (
			<div key={item.id}>
				{this.checkboxOrExpand(item, class2add)}
				<div className={_class}>
					{item.children ? item.children.map((child) => this.renderChildren(child)) : null}
				</div>
			</div>
			
		);
	}

	render() {
		this.visibleLayersListIds = [];
		this.props.visibleLayers.map((l) => this.visibleLayersListIds.push(l.id));

		return (
			<div id='map-layers-tree-view'>

				{this.props.maplayers.map((item) =>
					this.renderChildren(item)
				)}

			</div>
		);
		
	}
}
MapLayers.propTypes = {
	getMapLayers: PropTypes.func.isRequired,
	maplayers: PropTypes.array.isRequired,
	visibleLayers: PropTypes.array.isRequired,
	changeOneMapLayer: PropTypes.func.isRequired,
	addVisibleLayer: PropTypes.func.isRequired,
	removeVisibleLayer: PropTypes.func.isRequired,
	projects: PropTypes.object.isRequired,
	isGisOnly: PropTypes.bool.isRequired,
	isGisAdmin: PropTypes.bool.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Explorer/MapLayers.js